import React, { useState, useEffect, useRef } from 'react';
import PCLoginPage from '../components/PCLoginPage/PCLoginPage';
import H5LoginPage from '../components/H5LoginPage/H5LoginPage';
import Captcha from '../components/Captcha/Captcha';
import InvalidAidPage from '../components/InvalidAidPage/InvalidAidPage';
import http from '../utils/request';

const LoginPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isCaptchaPassed, setIsCaptchaPassed] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [verifyError, setVerifyError] = useState('');
  const [isAidValid, setIsAidValid] = useState(true);
  const [aidErrorTitle, setAidErrorTitle] = useState('尚未登录');
  const [aidErrorMessages, setAidErrorMessages] = useState([
    '请从业务目标网站进行登录',
    '不要使用收藏的登录页面作为快捷登录链接'
  ]);
  const intervalIdRef = useRef(null);
  const hasValidatedOnMount = useRef(false);

  // 验证AID
  const validateAid = async (isInitial = false) => {
    try {
      const response = await http.get('/api/base/sso/validAid');
      if (response?.data?.result) {
        setIsAidValid(true);
      } else {
        setIsAidValid(false);
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
        }
        if (!isInitial) {
          setAidErrorTitle('会话已结束');
          setAidErrorMessages(['由于您最近没有任何活动，当前登录会话已结束，请关闭当前窗口重新尝试登录']);
        }
      }
    } catch (error) {
      setIsAidValid(false);
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
      if (!isInitial) {
        setAidErrorTitle('会话已结束');
        setAidErrorMessages(['由于您最近没有任何活动，当前登录会话已结束，请关闭当前窗口重新尝试登录']);
      }
    }
  };

  useEffect(() => {
    if (!hasValidatedOnMount.current) {
      console.log('validateAid');
      validateAid(true);
      hasValidatedOnMount.current = true;
    }
    
    intervalIdRef.current = setInterval(validateAid, 2000);
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const handleCaptchaTokenReceived = async ({token, version, site}) => {
    if (!token) {
      setVerifyError('验证码token为空');
      return;
    }

    setIsVerifying(true);
    setVerifyError('');

    try {
      const response = await http.post('/api/v2/step/verifyToken', { token, version,site });

      if (response.data && response.data.code === 0 && response.data.result === true) {
        // 验证成功
        setIsCaptchaPassed(true);
        console.log('验证码校验成功:', response.data.message);
      } else {
        // 验证失败
        setVerifyError(response.data?.message || '验证码校验失败');
        console.error('验证码校验失败:', response.data);
      }
    } catch (error) {
      console.error('验证码校验请求失败:', error);
      // 如果错误对象包含响应信息，优先使用响应中的错误信息
      if (error.response && error.response.data && error.response.data.message) {
        setVerifyError(error.response.data.message);
      } else {
        setVerifyError(error.message || '网络请求失败，请重试');
      }
    } finally {
      setIsVerifying(false);
    }
  };

  if (!isAidValid) {
    return <InvalidAidPage title={aidErrorTitle} messages={aidErrorMessages} />;
  }

  return (
    <div className="login-page">
      {isMobile ? <H5LoginPage /> : <PCLoginPage />}
      {/* {isCaptchaPassed && (isMobile ? <H5LoginPage /> : <PCLoginPage />)}
      {!isCaptchaPassed && (
        <div>
          <Captcha onTokenReceived={handleCaptchaTokenReceived} isMobile={isMobile} />
          {isVerifying && <div className="verifying-message">正在验证验证码...</div>}
          {verifyError && <div className="error-message" style={{color: 'red', marginTop: '10px'}}>{verifyError}</div>}
        </div>
      )} */}
    </div>
  );
};

export default LoginPage; 